﻿import { createSlice } from '@reduxjs/toolkit';

/* Creating a slice of the state for stuff related to the map. */
const speedcurveStateSlice = createSlice({
  name: 'speedcurveState',
  initialState: {
    isInProgress: false,
  },
  reducers: {
    start: (state) => {
      state.isInProgress = true;
    },
    end: (state) => {
      state.isInProgress = false;
    },
  },
});

export default speedcurveStateSlice;
